// API 配置 - 从环境变量获取
export const API_BASE_URL = '/api';

// 应用配置
export const APP_CONFIG = {
  title: import.meta.env.VITE_APP_TITLE || '果多美记账管理系统 - 管理后台',
  version: import.meta.env.VITE_APP_VERSION || '1.0.0',
  enableMock: import.meta.env.VITE_ENABLE_MOCK === 'true',
};
